import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Problem } from './components/Problem';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Comparison } from './components/Comparison';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
import { TESTIMONIOS_BOTTOM, TESTIMONIOS_TOP } from './data/content';
export function App() {
  return <div className="w-full bg-ink font-sans text-violeta-50" data-id="element-0" data-mp="2wk0a329kipw1">
      <Hero data-id="element-1" data-mp="2wifgpfyzpczr" />
      <main data-id="element-2" data-mp="2whx9joashed2">
        <Testimonials label="Mujeres que ya lo tienen" title="Reales. Argentina." testimonios={TESTIMONIOS_TOP} data-id="element-3" data-mp="2wi5l9cv6edmo" />
        <Problem data-id="element-4" data-mp="23u9q4cl98ts0" />
        <Tomos data-id="element-5" data-mp="23ut97wmn5o7m" />
        <Bonos data-id="element-6" data-mp="23t8gmcjw0fce" />
        <Countdown data-id="element-7" data-mp="3ijxnsm94vshs" />
        <Pricing data-id="element-8" data-mp="3ikh98cxzsz0k" />
        <Comparison data-id="element-9" data-mp="3iiwfuqnezm4a" />
        <Testimonials label="❤️ Más testimonios" title="Historias reales — Argentina" testimonios={TESTIMONIOS_BOTTOM} data-id="element-10" data-mp="3ijftvw9y1qd1" />
        <Faq data-id="element-11" data-mp="3rbrcwx2qabiz" />
        <FinalCta data-id="element-12" data-mp="3rdaselgk8ijp" />
      </main>
      <Footer data-id="element-13" data-mp="3rd189ei755lx" />
      <StickyBar data-id="element-14" data-mp="3relv0hy9rk98" />
    </div>;
}